import script from "./CourseSessionList.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseSessionList.vue?vue&type=script&setup=true&lang=js"

import "./CourseSessionList.vue?vue&type=style&index=0&id=71a3f9ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71a3f9ac"]])

export default __exports__